var exports = {
  "S": "x127c5a35--397a00--pagination-sentinel",
};

module.exports = exports;
